import * as types from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    gearsData: [],
    gearsFetchSuccess: false,
    gearsFetchingFail: false,
    gearsFetching: false
};

// ======= Fetching Handlers =======
const fetchGears = (state, action) => {
    return {
        ...state,
        gearsFetchSuccess: false,
        gearsFetchingFail: false,
        gearsFetching: false
    };
};
const fetchGearsFetching = (state, action) => {
    return {
        ...state,
        gearsFetchSuccess: false,
        gearsFetching: true
    };
};
const fetchGearsSuccess = (state, action) => {
    return {
        ...state,
        gearsData: {
            ...action
        },
        gearsFetchSuccess: true,
        gearsFetchingFail: false,
        gearsFetching: false
    };
};
const fetchGearsFail = (state, action) => {
    return {
        ...state,
        gearsActivitiesFetchSuccess: false,
        gearsActivitiesFetchingFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [types.FETCH_GEARS_SUCCESS]: fetchGearsSuccess,
    [types.FETCH_GEARS_FAIL]: fetchGearsFail,
    [types.FETCH_GEARS_FECTHING]: fetchGearsFetching
};

// ======= Selectors =======
export const getGears = (state) => {
    return state.gears ? state.gears : [];
};
export const getGearsFetching = (state) => {
    return state.gears ? state.gears.gearsFetching : false;
};
export const gearsFetchSuccess = (state) => {
    return state.gears ? state.gearsFetchSuccess : false;
};
// ======= Default Action =======
export default function gears(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
